import styled from 'styled-components'
import { lighten } from 'polished'
import theme from '../../styles/theme'

export const Divider = styled.hr`
  border: 0.5px solid ${lighten(0.75, theme.color.black)};
`



// WEBPACK FOOTER //
// ./src/components/Divider/index.tsx